import { render, staticRenderFns } from "./MealDesignLink.vue?vue&type=template&id=b5c234e6&"
import script from "./MealDesignLink.vue?vue&type=script&lang=js&"
export * from "./MealDesignLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports